<template>
  <div>
    <slot v-bind:open="open"></slot>

    <modal size="lg" :show="show" @closeModal="close">
      <div class="px-1 py-2 sm:p-2">
        <h3 class="text-lg leading-6 font-medium text-gray-900 mb-2">
          Update Items Selected
        </h3>

        <table class="min-w-full mt-2">
          <thead>
          <tr>
            <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Item Code
            </th>
            <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Unit
            </th>
            <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Qty Ordered
            </th>
            <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Unit Price
            </th>

            <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Total Discount
            </th>

            <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Total
            </th>
          </tr>
          </thead>
          <tbody class="bg-white">
          <tr v-for="item in form.items" :key="`update-${item.id}`">
            <td class="px-2 py-4 whitespace-nowrap border-b border-gray-200 text-sm leading-5 font-medium text-gray-900">
              <div>{{ item.description }}</div>
              {{ item.item_code }}
            </td>
            <td class="px-2 py-4 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-900">
              {{ item.unit }}
            </td>
            <td class="px-2 py-4 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-900">
              <input type="number" class="form-number-text w-16 p-2 rounded bg-gray-100 text-center mr-2 border-0" :min="0" v-model.number="item.quantity_approved"/>
            </td>
            <td class="px-2 py-4 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-900">
              MVR
              <input type="number" class="form-number-text w-16 p-2 rounded bg-gray-100 text-center mr-2 border-0" :min="0" v-model.number="item.unit_price"/>
            </td>

            <td class="px-2 py-4 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-900">
              MVR
              <input type="number" class="form-number-text w-16 p-2 rounded bg-gray-100 text-center mr-2 border-0" :min="0" v-model.number="item.discount_applied"/>
            </td>

            <td class="px-2 py-4 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-900">
              {{ (item.quantity_approved * item.unit_price) - item.discount_applied }}
            </td>
          </tr>
          </tbody>
        </table>


        <div class="mt-4 flex justify-end">
          <button class="btn-primary" @click="updateItems">Update Items</button>
        </div>

      </div>
    </modal>
  </div>
</template>

<script>
import Modal from "../../../../Shared/Modal.vue";

export default {
  name: 'UpdateOrderItemsModal',
  components: {Modal},

  props: {
    items: Array,
    selectedItems: Object,
    updateOrderItemsUrl: String,
    orderId: Number,
  },

  data() {
    return {
      show: false,
      form: this.$inertia.form({
        order_id: this.orderId,
        items: [],
      })
    }
  },

  computed: {
    getItem() {
      return itemId => {
        return this.items.find(item => item.id === parseInt(itemId))
      }
    }
  },

  methods: {
    open() {
      this.form.items = Object.keys(this.selectedItems)
        .filter(id => this.selectedItems[id])
        .map(id => this.getItem(id) );
      this.show = true
    },
    close() {
      this.form.reset('items')
      this.show = false
    },

    updateItems() {
      this.form.post(this.updateOrderItemsUrl, {
        onSuccess: () => {
          this.close()
          this.$emit('updated')
        }
      })
    }
  }
}
</script>
